export default function FaqSection({ title, items }) {
  return (
    <section className="mt-12" aria-labelledby="faq-heading">
      <h2 id="faq-heading" className="text-2xl font-bold text-white mb-6">
        {title}
      </h2>
      <div className="space-y-4">
        {items.map((item, index) => (
          <details
            key={index}
            className="group rounded-xl border border-slate-700 bg-slate-800/50 open:bg-slate-800"
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
          >
            <summary className="cursor-pointer list-none px-5 py-4 font-medium text-white flex justify-between items-center gap-4">
              <h3 className="text-base font-medium m-0" itemProp="name">
                {item.q}
              </h3>
              <span className="text-emerald-400 group-open:rotate-45 transition-transform text-xl shrink-0" aria-hidden="true">
                +
              </span>
            </summary>
            <div
              className="px-5 pb-4 text-slate-300 text-sm leading-relaxed border-t border-slate-700/50 pt-3"
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              <p itemProp="text" className="m-0">
                {item.a}
              </p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
